import React, { useEffect } from 'react';
import { useState, useRef } from 'react';
import logoImg from "../../../assets/images/logo.png"
import "../../../SplashScreen/SplashScreen.css"
import { getIntroVideoUrl, preloadIntroVideo } from '../../../video/introVideo';
import { isUnlocked, playFx, stopAudioByName } from '../../../audio/audioManager';
import introBg from "../../../assets/musics/Intro.mp3"
import inBetween from "../../../assets/musics/inBetween.mp3"
import { globalVars } from '../../../App';
import CommonButton, { btnColors, btnSizes } from '../../../Objects/CommonButton/CommonButton';
import Game, { firebaseCommands } from '../Game';

// Avvia il video e lo rende visibile solo quando è davvero in movimento: play() ha una latenza di avvio e,
// mostrandolo subito, si vede il primo fotogramma fermo per qualche istante prima che parta.
// L'opacità resta a 0.01 e non a 0, perché a 0 il browser potrebbe non presentare i fotogrammi.
function startVideoPlayback(video, onReveal) {
    let revealed = false;
    const reveal = () => {
        if (revealed) return;
        revealed = true;
        if (onReveal) onReveal();
        video.classList.add("fadein");
    };

    video.style.display = "block";
    video.style.opacity = "0.01";

    if (typeof video.requestVideoFrameCallback === "function") {
        const onFrame = (now, metadata) => {
            if (metadata.mediaTime > 0) {
                reveal();
            } else {
                video.requestVideoFrameCallback(onFrame);
            }
        };
        video.requestVideoFrameCallback(onFrame);
    } else {
        video.addEventListener("playing", reveal, { once: true });
    }
    //sicurezza: se gli eventi non arrivano il video compare comunque
    setTimeout(reveal, 400);

    const playing = video.play();
    if (playing && playing.catch) playing.catch(reveal);
}


const CutScene = ({ intro, onEnd, destroy, last, musicVolume, canSkip, externalAudio = false }) => {
    const cutSceneRef = useRef(null);
    const videoRef = useRef(null);
    const logo = useRef(null);
    const splash = useRef(null);
    const cutsceneTrackRef = useRef({ name: null, url: null });
    const usingLocalAudioRef = useRef(false);
    const cutsceneAudioStarted = useRef(false);
    //const softInterval = useRef(null);

    //console.log("cutscene "+ onEnd);

    const [hideVideo, setHide] = useState(false);
    const [showSkip, setSkipable] = useState(false);
    //pulsante "Salta" (pulsante): hidden (invisibile e non premibile) -> in (compare con un fade) -> out (sparisce con un fade)
    const [skipPhase, setSkipPhase] = useState("hidden");
    //il video è già scaricato (Blob) se i giocatori hanno passato un po' di tempo nel lobby
    const [videoSrc, setVideoSrc] = useState(() => getIntroVideoUrl());

    useEffect(() => {
        if (globalVars.type == "d" && !videoSrc) {
            preloadIntroVideo().then(setVideoSrc);
        }
    }, []);

    useEffect(() => {
        let videoElement, onLoaded, onEnded;
        if(globalVars.type == "b") {
            if (cutSceneRef.current) {
                cutSceneRef.current.classList.remove("fadeout");
                cutSceneRef.current.classList.add("fadein");
            }
        }
        
        
        //se deve mostrare lo splash, attendi il fade in prima di caricare il video
        if(intro) {
            if (cutSceneRef.current) {
                cutSceneRef.current.classList.remove("crossfade");
            }
            splash.current.classList.add("fadein");
            setTimeout(() => {
                logo.current.classList.add("fadein");
                //softInterval.current = setInterval(softFade, 1700);
            }, 300);
            
        } else {
            if(globalVars.type == "d") {
                if (cutSceneRef.current) {
                    cutSceneRef.current.classList.add("crossfade");
                }
                videoRef.current.style.display = "block";
            }
        }

        if(globalVars.type == "d") {
            // con 'loadeddata' parte la cutscene (nell'intro il video viene prima fermato)
            videoElement = videoRef.current;
            onLoaded = () => {
                if (videoElement) {
                    videoElement.muted = true;
                    videoElement.volume = 0;
                }

                //fade out splash e avvio manuale del video
                if(intro) {
                    videoElement.pause(); // Ferma il video non appena viene caricato

                    setTimeout(() => {
                        //clearInterval(softInterval.current);
                        if (splash.current) {
                            splash.current.classList.remove("fadein");
                        }
                        if (logo.current) {
                            logo.current.classList.remove("fadein");
                            logo.current.classList.add("fadeout");
                        }
                        setTimeout(() => {
                            //lo splash sfuma insieme al video, quando questo parte davvero
                            startVideoPlayback(videoElement, () => {
                                if (splash.current) {
                                    splash.current.classList.add("fadeout");
                                }
                            });

                            firebaseCommands.startVideo.call(firebaseCommands.creator, last);
                        }, 300);
                        
                        
                        if (!externalAudio) {
                            playCutsceneAudio(0);
                        }

                    }, 1000);
                } else {
                    if (videoElement) {
                        videoElement.muted = true;
                        videoElement.volume = 0;
                    }
                    startVideoPlayback(videoElement);
                    firebaseCommands.startVideo.call(firebaseCommands.creator, last);
                    if(!last && !externalAudio) {
                        playCutsceneAudio(0);
                    }
                }
            };

            onEnded = () => {
                onEnd();
                setHide(true);
                document.querySelector(".cutScene").style.display = "none";
                //se nessun audio locale terminerà la cutscene (audio esterno, bloccato o assente) la chiude il video
                if (!usingLocalAudioRef.current) {
                    destroy(false);
                }
            };

            videoElement.addEventListener('loadeddata', onLoaded, { once: true });
            videoElement.addEventListener('ended', onEnded);
            //il video da Blob può essere già pronto prima che l'effect registri il listener
            if (videoElement.readyState >= 2) {
                videoElement.removeEventListener('loadeddata', onLoaded);
                onLoaded();
            }
        }

        const softFade = () => {
            logo.current.classList.remove("soft-fadein");

            logo.current.classList.add("soft-fadeout");
            setTimeout(() => {
                logo.current.classList.remove("soft-fadeout");
                logo.current.classList.add("soft-fadein");
            }, 700);
        }

        return () => {
            //clearInterval(softInterval.current)
            //softInterval.current = null;
            if(globalVars.type == "d" && videoElement) {
                // Rimuovi i listener quando il componente viene smontato
                videoElement.removeEventListener('loadeddata', onLoaded);
                videoElement.removeEventListener('ended', onEnded);
            }
        };
    }, []);

    useEffect(() => {
        if(globalVars.type == "b" && typeof onEnd != "function" && onEnd == true) {
            //console.log("onEnd TRUE");
            //clearInterval(softInterval.current);
            //il pulsante ha ricevuto l'ordine di terminare l'animazione
            if (cutSceneRef.current) {
                cutSceneRef.current.classList.remove("fadein");
                cutSceneRef.current.classList.add("fadeout");
            }
            splash.current.classList.remove("fadein");
            logo.current.classList.remove("fadein");
            logo.current.classList.add("fadeout");
            //se il pulsante non è ancora comparso resta nascosto
            setSkipPhase((phase) => phase === "in" ? "out" : phase);
            setTimeout(() => {
                splash.current.classList.add("fadeout");
                setTimeout(() => {
                    destroy(false);   //viene passata la funzione useState, imposta il valore di cutScene a false
                }, 300);
            }, 300);
        }
    }, [onEnd])

    useEffect(() => {
        if(canSkip) {
            if(globalVars.type == "b") {
                //l'utente può skippare l'intro
                setTimeout(() => {
                    //se nel frattempo la cutscene sta già finendo non deve ricomparire
                    setSkipPhase((phase) => phase === "hidden" ? "in" : phase);
                    setSkipable(true);
                }, 1200);
            } else {
                //l'intro è stata skippata
                if (!videoRef.current) {
                    const trackName = cutsceneTrackRef.current.name;
                    stopAudioByName(trackName);
                    return;
                }
                videoRef.current.currentTime = videoRef.current.duration; // Porta il video alla fine
                videoRef.current.dispatchEvent(new Event('ended'));
                const trackName = cutsceneTrackRef.current.name;
                stopAudioByName(trackName);
                if(!last) {
                    playCutsceneAudio(6.85, true);
                }
            }
            
        }
    }, [canSkip]);

    useEffect(() => {
        const handleVisibility = () => {
            const video = videoRef.current;
            if (!video) return;
            if (document.hidden) {
                if (!video.paused) {
                    video.pause();
                }
            } else {
                if (video.paused && video.style.display === "block") {
                    video.play().catch(() => {});
                }
            }
        };
        document.addEventListener('visibilitychange', handleVisibility);
        return () => document.removeEventListener('visibilitychange', handleVisibility);
    }, []);

    const playCutsceneAudio = (offset = 0, force = false) => {
        if (!isUnlocked()) return;
        if (cutsceneAudioStarted.current && !force) return;
        const track = intro
            ? { name: "cutscene_intro", url: introBg }
            : { name: "cutscene_inbetween", url: inBetween };
        cutsceneTrackRef.current = track;
        stopAudioByName(track.name);
        usingLocalAudioRef.current = true;
        cutsceneAudioStarted.current = true;
        playFx(track.name, track.url, { target: 'music', offset }).then((src) => {
            if (src && !externalAudio) {
                //addEventListener e non onended: onended è già usato da playFx per la pulizia del registro
                src.addEventListener('ended', () => {
                    cutsceneAudioStarted.current = false;
                    destroy(false);
                }, { once: true });
            }
        });
    };
  
  return (
    <div className='cutScene' ref={cutSceneRef}>
          {intro && !hideVideo && <div className='splash-screen' ref={splash}>
            <img src={logoImg} alt="Logo" className="_logo" ref={logo}/>
            {globalVars.type == "b" && <div className={"cutscene-skip cutscene-skip-" + skipPhase}>
                <CommonButton
                    id="skip"
                    txt="Salta"
                    color={btnColors.orange}
                    size={btnSizes.default}
                    enabled={showSkip}
                    click={() => {
                        if(showSkip) {
                            setSkipable(false);
                            firebaseCommands.skipVideo.call(firebaseCommands.creator);
                        }
                    }}
                ></CommonButton>
            </div>}
          </div>}

          {globalVars.type == "d" && !hideVideo && <video
              className="cutscene-video"
              style={{display: "none"}}
              ref={videoRef}
              src={videoSrc || undefined}
              width="100%"
              height="100%"
              muted
              playsInline
              preload="auto"
          >
              Il tuo browser non supporta i video.
          </video>}
      </div>
  );
}

export default CutScene;